<template>
	<BasePopover class="select-none visible-scrollbars">
		<template v-if="$slots.header" #header>
			<slot name="header" />
		</template>
		<!-- Search -->
		<div class="bg-gray-600 h-32 mx-4 px-8 gap-8 rounded flex items-center mb-6">
			<BaseIcon name="mono/search" class="flex-none w-16 h-16" />
			<input
				ref="searchInput"
				:value="modelValue"
				:placeholder="searchPlaceholder"
				type="text"
				class="w-full bg-transparent text-gray-100"
				autofocus
				data-test="search-input"
				@input="$emit('update:modelValue', $event.target.value)"
			/>
			<button
				v-if="modelValue"
				class="flex-none focus:text-gray-100 focus:ring-0"
				@click="resetSearch"
				@keydown.enter="resetSearch"
			>
				<BaseIcon name="mono/delete" class="w-10 h-10" />
			</button>
		</div>
		<slot />
		<template v-if="$slots.footer" #footer>
			<slot name="footer" />
		</template>
	</BasePopover>
</template>

<script>
export default {
	name: 'BaseSearchablePopover',
	props: {
		title: {type: String, default: ''},
		modelValue: {type: String, default: ''},
		searchPlaceholder: {type: String, default: ''},
		searchable: Boolean,
	},
	emits: ['update:modelValue'],
	async mounted() {
		await this.$nextTick()
		this.$refs.searchInput?.focus()
	},
	methods: {
		resetSearch() {
			this.$emit('update:modelValue', '')
		},
	},
}
</script>
